import { createSlice } from "@reduxjs/toolkit";
import buildAction from "../../helpers/buildAction.ts";
import thunks from "./thunks";
import { IUserSlice } from "@/redux/slices/user/types";

export const initialState: IUserSlice = {
  user: {
    loading: true,
    authenticated: false,
    addresses: {
      options: [],
      loading: false,
    },
    payment_options: {
      options: [],
      loading: false,
    },
    call_credit: {
      balance: null,
    },
  },
  cart: {
    token: null,
    cost_gross: 0,
    cost_net: 0,
    items: [],
    loading: true,
    ns_groups: {},
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    thunks.forEach((thunk) => buildAction(builder, thunk));
  },
});

export default userSlice.reducer;
export const {} = userSlice.actions;
